import angular from 'angular';

import SmartyService from './smarty-provider';

import DisableArrowsDirective from './disable-arrows';
import RASmartyStreetsDirective from './ra-smarty-streets';
import SmartyValidatorDirective from './smarty-validator';

import * as HPConfig from '../../config/app.config';


// no controller
import './smarty-styles.scss';

export default angular.module('app.smarty', [])
    .constant('HPConfig', HPConfig.default)
    .provider('raSmarty', SmartyService)
    .directive('disableArrows', DisableArrowsDirective)
    .directive('smartyStreetsInput', RASmartyStreetsDirective)
    .directive('smartyValidator', SmartyValidatorDirective)
    .run(($templateCache) => {
        $templateCache.put('app/common/smarty/smarty-template.html', require('./smarty-template.html')); // eslint-disable-line global-require
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/common/smarty/index.js